export const SET_ACTIVE_METRIC = 'SET_ACTIVE_METRIC';

export const SET_INACTIVE_METRICS = 'SET_INACTIVE_METRICS';
